<template>
  <div class="tile-header pt-2">
    <div class="tile-text" >
      <strong>{{ header }}</strong>
    </div>
    <!-- :class="[{'tile-text-questions': hasQuestionBar}]" -->
    <!-- <div  v-if="hasQuestionBar"
          class="tile-questions">
      <treeselect
                  :clearable="false"
                  placeholder="KPI ..." />
    </div> -->
    <div class="tile-icons right" v-if="isEditable">
      <font-awesome-icon  class="clickable"
                          style="z-index: 500;"
                          @click="$emit('edit')"
                          :icon="['fas', 'edit']"
                          />
      <!-- <font-awesome-icon  class="clickable"
                          :icon="['fas', 'undo-alt']"
                          @click="$emit('undo')"
                          />
      <font-awesome-icon  class="clickable"
                          :icon="['fas', 'save']"
                          @click="$emit('save')"
                          /> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      header:           { type: String,   required: true },
      isEditable:       { type: Boolean,  required: true },
      hasQuestionBar:   { type: Boolean,  default: false }
    }
  }
</script>

<style lang="scss" scoped>

.right {
  min-width: 3rem;
}

.tile-icons {
  padding-right: 0.5rem;
  width: 5rem;
  z-index: 2;
}

.tile-text {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 1rem;
  width: calc(100% - 6rem);
}

.tile-text-questions {
  width: calc(100% - 66rem)!important;
}

// .tile-questions {
//   width: 60rem;
//   padding-right: 16rem;
// }
</style>
